import {postToParent} from './messageHandlers'

const MAX_INNER_TEXT_LENGTH = 100

export function reportClick(event: MouseEvent): void {
    const target = event.target as Element | null
    if (!target) {
        return
    }

    postToParent({
        type: 'click',
        selector: buildCssSelector(target),
        innerText: resolveInnerText(target)
    })
}

function resolveInnerText(element: Element): string | null {
    if (!(element instanceof HTMLElement) || isSensitiveElement(element)) {
        return null
    }

    return element.innerText.trim().slice(0, MAX_INNER_TEXT_LENGTH)
}

function isSensitiveElement(element: HTMLElement): boolean {
    const sensitiveInputTypes = ['password', 'email', 'tel', 'number']
    if (element instanceof HTMLInputElement) {
        return sensitiveInputTypes.includes(element.type)
    }

    return false
}

function buildCssSelector(element: Element): string {
    if (element.id) {
        return `#${element.id}`
    }

    const tag = element.tagName.toLowerCase()
    const classes = Array.from(element.classList).map(c => `.${c}`).join('')

    return `${tag}${classes}`
}
